module.exports = __webpack_public_path__ + "img/jcua-logo-mono-reversed-2018.18247fbe.svg";